import type { ReactNode } from 'react'
import { Lock, type LucideIcon } from 'lucide-react'
import { cn } from '@/utils/cn'

interface ReadOnlyBannerProps {
  children: ReactNode
  icon?: LucideIcon
  className?: string
}

/** Amber notice shown wherever plan content is visible but not editable. */
export function ReadOnlyBanner({
  children,
  icon: Icon = Lock,
  className,
}: ReadOnlyBannerProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 px-4 py-2 bg-amber-50 border border-amber-200 rounded-md text-amber-800 text-sm',
        className
      )}
    >
      <Icon className="h-4 w-4 shrink-0" />
      <span>{children}</span>
    </div>
  )
}
